<template>
  <div class="top-header" :style="{background: bg}">
    <div class="header-content" :class="this.$root.isFill ? 'header-fill': ''">
      <ln-layout :left-width="realLogoWidth">
        <div slot="left" class="header-left" :style="{width: realLogoWidth}" @click="gotoHome">
          <div class="logo-img left">
            <img src="../assets/img/home/logo.png" />
          </div>
          <div class="logo-text left">
            <div class="logo-title">点度智联云</div>
            <div class="logo-sub">DianDu-IoT</div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="header-nav-list left">
          <div class="nav-item-block left" v-for="(nav, index) in menus" :key="index">
            <span class="nav-item" @click="executeNav(nav)">{{nav.label}}</span>
          </div>
        </div>
        <div class="header-user right" @click="gotoLogin">
          <!--<span>
            <icon name="user-alt"/>
            <span>登录</span>
          </span>-->
          <div class="user-icon left">
            <icon name="user-circle"/>
          </div>
          <div class="user-name left">控制台</div>
        </div>
      </ln-layout>
    </div>
    <div class="header-nav-mobile" @click="showMenuPanel">
      <div class="nav-fold-wrap">
        <div class="nav-fold">
          <icon name="bars" class="nav-fold-icon"></icon>
        </div>
      </div>
      <div class="nav-fold-menu" v-if="showMenu">
        <div class="fold-menu-stance-block"></div>
        <div class="fold-menu-item" v-for="nav in menus" :key="nav.label" @click="executeNav(nav)">{{nav.label}}</div>
        <div class="fold-menu-stance-block"></div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
import LnLayout from '../components/LnLayout.vue'

let bgRGB = '6, 41, 81'

export default {
  name: 'TopHeader',
  components: {
    LnLayout
  },
  props: {
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      bg: 'rgb(' + bgRGB + ')',
      menus: [
        {
          url: '/index',
          label: '首页'
        },
        {
          url: '/case',
          mUrl: '/case/mobile/gLvJiPage',
          label: '项目案例'
        },
        {
          url: '/about',
          label: '关于我们'
        }
      ],
      showMenu: false
    }
  },
  computed: {
    realLogoWidth () {
      if (this.isCollapse === true) {
        return '64px'
      } else {
        return '200px'
      }
    }
  },
  created () {
    this.refreshTransparent()
    this.enableTransparent()
  },
  methods: {
    enableTransparent () {
      window.addEventListener('scroll', this.refreshTransparent)
    },
    refreshTransparent () {
      let t = document.documentElement.scrollTop || document.body.scrollTop
      let dim = t / 450
      if (dim > 1) {
        dim = 1
      }
      this.bg = 'rgba(' + bgRGB + ',' + dim + ')'
    },
    disableTransparent () {
      window.removeEventListener('scroll', this.refreshTransparent)
    },
    executeNav (nav) {
      if (nav.label === '项目案例') {
        if (this.$root.mFlag) {
          this.$root.isFill = false
          this.$router.push({path: nav.mUrl})
        } else {
          this.$root.isFill = true
          this.$router.push({path: nav.url})
        }
      } else {
        this.$root.isFill = false
        this.$router.push({path: nav.url})
      }
    },
    gotoHome () {
      this.$router.push({path: '/index'})
    },
    gotoLogin () {
      window.location.href = '/console.html'
    },
    showMenuPanel () {
      this.showMenu = !this.showMenu
    }
  },
  beforeDestroy () {
    this.disableTransparent()
  }
}
</script>

<style scoped>
  .top-header {
    position: fixed;
    width: 100%;
    height: 70px;
    top: 0;
    left: 0;
    z-index: 100;
    /*border-bottom: 1px solid #e0e0e0;*/
  }
  .header-content {
    max-width: 1440px;
    height: 100%;
    padding: 0 15px;
    margin: 0 auto;
    color: #ffffff;
    box-sizing: border-box;
  }
  .header-fill {
    width: 100%;
    max-width: unset;
  }
  .header-left {
    margin-top: 10px;
    cursor: pointer;
  }
  .logo-img img {
    height: 46px;
    width: 46px;
    padding: 4px 3px 7px 0;
  }
  .logo-text {
    line-height: 18px;
  }
  .logo-text:hover {
    color: #C752FB;
  }
  .logo-title {
    font-size: 18px;
    padding: 6px 0 3px 0;
    margin-top: 3px;
  }
  .logo-sub {
    font-size: 14px;
    letter-spacing: 2px;
  }
  .nav-item {
    font-size: 16px;
    padding: 0 20px;
    display: inline-block;
    line-height: 32px;
    cursor: pointer;
    margin-top: 19px;
    margin-right: 10px;
    border-radius: 16px;
  }
  .nav-item-active {
    font-weight: bold;
    background: linear-gradient(to right,#c352fa,#4c46bd);
  }
  .nav-item:hover {
    font-weight: bold;
    background: linear-gradient(to right,#c352fa,#4c46bd);
  }
  .header-user {
    line-height: 70px;
    font-size: 16px;
    height: 70px;
    overflow: hidden;
    cursor: pointer;
  }
  .user-icon {
    font-size: 24px;
    margin-right: 8px;
  }
  .user-name {
    font-size: 16px;
  }
  .header-nav-mobile {
    display: none;
  }
  .nav-fold-wrap {
    width: 60px;
    height: 70px;
    position: absolute;
    top: 0;
    right: 3px;
    text-align: center;
    cursor: pointer;
  }
  .nav-fold {
    width: 36px;
    height: 36px;
    margin: 18px auto 0 auto;
    text-align: center;
    border-radius: 18px;
    cursor: pointer;
    background: linear-gradient(to right,#c352fa,#4c46bd);
  }
  .nav-fold-icon {
    width: 20px;
    height: 20px;
    margin-top: 8px;
    color: #ffffff;
  }
  .nav-fold-menu {
    position: absolute;
    width: 100%;
    height: 0;
    top: 70px;
    left: 0;
    background-color: #062951;
    border-bottom: 1px solid #e0e0e0;
    box-sizing: border-box;
    transition: height 0.5s;
    -moz-transition: height 0.5s;
    -webkit-transition: height 0.5s;
    -o-transition: height 0.5s;
    overflow: hidden;
  }
  .fold-menu-stance-block {
    width: 100%;
    height: 50px;
  }
  .fold-menu-item {
    width: 100%;
    height: 42px;
    line-height: 42px;
    text-align: center;
    color: #ffffff;
    font-size: 16px;
    cursor: pointer;
    /*background: linear-gradient(to right,#c352fa,#4c46bd);*/
  }
  .fold-menu-item:hover {
    color: #ffffff;
    font-size: 18px;
    background: linear-gradient(to right,#c352fa,#4c46bd);
  }
  .header-nav-mobile:hover .nav-fold-menu{
    /*display: block;*/
    height: 236px;
  }
  @media all and (max-width: 650px) {
    .top-header {
      background: #062951 !important;
      /*background: #010D1C !important;*/
    }
    /*.logo-text {
       display: none;
     }*/
    .logo-title {
      font-size: 16px;
      padding: 8px 0 2px 0;
    }
    .logo-sub {
      font-size: 12px;
      margin-top: -3px;
    }
    .header-nav-list {
      display: none;
    }
    .header-nav-mobile {
      display: block;
    }
    .header-user {
      margin-right: 51px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TopHeader.vue